import { collectButtonComponentParams } from 'strapi/component/landingButton';
import { collectImageComponentParams } from 'strapi/component/shared/collector';
import { PageType, PageTypes } from 'strapi/page/types';
import { ReactComponentBuildResponse } from 'strapi/types';

import { ReactComponentType } from '../types';

import { HeaderBanner } from './HeaderBanner';
import { HeaderBannerProps, HeaderBannerStrapiComponent } from './types';

export const collectHeaderBannerComponentParams = (
  data: HeaderBannerStrapiComponent,
  page: PageTypes
): HeaderBannerProps => {
  return {
    text: data.text,
    description: data.description,
    button: collectButtonComponentParams(page, data.primaryButton),
    backgroundGradient: data.backgroundGradient,
    image: collectImageComponentParams(data.rightImage),
    showCompanies: !!data.brands,
  };
};

export const collectHeaderBannerParams = (
  _: PageType,
  page: PageTypes
): ReactComponentBuildResponse<typeof HeaderBanner> | undefined => {
  if (!('headerBanner' in page) || !page.headerBanner) {
    return undefined;
  }

  return {
    component: ReactComponentType.HeaderBanner,
    props: collectHeaderBannerComponentParams(page.headerBanner, page),
  };
};
